import { throttle as baseThrottle } from 'lodash-es'
import { TParameter } from '@hfs/types/global'

export const throttle = <F extends (...args: any[]) => any>(
  cb: F,
  wait?: number,
  options?: TParameter<typeof baseThrottle, 2>
) => baseThrottle(cb, wait, options)
